/*
**************************************************************************
Title:          Uilities
Created By:     Pankaj Arora
Created on:     05/02/2018
Description:    Generic utilities across the app
**************************************************************************
*/
// create a unique uuid - uniqueness is not guaranteed.
// Make sure your code can handle it
export function uuid() {
    let result = '';
    for (let i = 0; i < 32; i++) {
        const random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            result += '-';
        }
        result += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random))
            .toString(16);
    }
    return result;
}
